export default __webpack_public_path__ + "static/join02-f4b271a58b020579b6889f3d8d53b1ec.png";